import * as React from "react";

/**
 * @returns the initial value even if it changes on subsequent renders.
 */
export function useInitial<T>(value: T) {
  return React.useRef(value).current;
}
